export default function BackButton(fallbackPath, { reload = false } = {}) {
  const referrer = document.referrer
  const referrerHostname = referrer ? new URL(referrer).hostname : null

  if (referrerHostname?.endsWith(window.location.hostname)) {
    if (reload) {
      location.replace(referrer)
    } else {
      window.history.back()
    }
  } else {
    location.href = fallbackPath
  }

  // Prevent the default link behavior
  return false
}
